module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead7-d096ea61b76eaf33f617ac7862565a65.jpg";